import React from "react"
import ParticipantSidebar from "../../../components/sidebars/ParticipantSidebar"
import ActivityLogSidebar from "../../../components/sidebars/ActivityLogSidebar"
import PageSidebarContent from "../../../components/sidebars/PageSidebarContent"
import ListPageView from "../../../components/ListPageView"
import PropTypes from "prop-types"

function RenderLayout(props) {
  const { ID_TEMPLATE, ID_BLOCKS, listViewCols } = props

  // Participant templates should render the participant contextual sidebar.
  const isParticipantRelated = [
    "custom_session_template_1",
    "custom_session_template_2",
    "custom_form_template_1",
    "custom_form_template_2",
  ]

  // Activity templates should render the activity contextual sidebar.
  const isActivityRelated = [
    "custom_activity_template_1",
    "custom_activity_template_2",
  ]

  const isParticipantTemplate = isParticipantRelated.includes(ID_TEMPLATE)
  const isActivityTemplate = isActivityRelated.includes(ID_TEMPLATE)

  return (
    <>
      {/* PageSidebarContent mounts into the global sidebar container, not this local layout. */}
      {isParticipantTemplate ? (
        <PageSidebarContent>
          <ParticipantSidebar />
        </PageSidebarContent>
      ) : null}

      {/* Keep activity sidebar registration separate for easier future expansion. */}
      {isActivityTemplate ? (
        <PageSidebarContent>
          <ActivityLogSidebar />
        </PageSidebarContent>
      ) : null}

      <div className="main-content">
        <ListPageView
          idTemplate={ID_TEMPLATE}
          idBlocks={ID_BLOCKS}
          columns={listViewCols}
          filterByParticipantId={isParticipantTemplate}
        />
      </div>
    </>
  )
}

RenderLayout.propTypes = {
  ID_TEMPLATE: PropTypes.string.isRequired,
  ID_BLOCKS: PropTypes.array.isRequired,
  listViewCols: PropTypes.array.isRequired,
}

export default RenderLayout
